document.addEventListener('DOMContentLoaded', function () {
    const $items = document.querySelectorAll('.item');
    const total = $items.length;
    
    $items.forEach((item, index) => {
        const number = `${total - index}.`;
        item.querySelector('.Index-number').textContent = number;
    });

    const modal = document.querySelector('.archive-modal');
    const modalBody = document.querySelector('.archive-modal-body');
    const closeModal = document.querySelector('.archive-modal-close');
    const links = document.querySelectorAll('.archive-modal-link');
    const cache = new Map();
    const CLOSE_BUTTON_DELAY = 1000;
    const MODAL_CLOSE_TRANSITION = 600;

    closeModal.style.display = 'none';

    function openModal() {
        document.body.style.overflow = 'hidden';
        modal.classList.remove('hidden');
        setTimeout(() => modal.classList.add('visible'), 10);
        setTimeout(() => closeModal.style.display = 'block', CLOSE_BUTTON_DELAY);
    }

    function closeModalFunction() {
        modal.classList.remove('visible');
        closeModal.style.display = 'none';
        setTimeout(() => {
            modal.classList.add('hidden');
            document.body.style.overflow = '';
        }, MODAL_CLOSE_TRANSITION);
    }

    links.forEach(link => {
        link.addEventListener('click', function () {
            const url = link.getAttribute('data-url');
            if (cache.has(url)) {
                modalBody.innerHTML = cache.get(url);
                openModal();
            } else {
                modalBody.innerHTML = 'Loading...';
                openModal();
                fetch(url)
                    .then(res => res.text())
                    .then(data => {
                        cache.set(url, data);
                        modalBody.innerHTML = data;
                    })
                    .catch(() => {
                        modalBody.innerHTML = 'Error loading content.';
                    });
            }
        });
    });

    closeModal.addEventListener('click', closeModalFunction);
    modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModalFunction();
    });

    // URL 파라미터 처리 (자동 모달 열기)
    const params = new URLSearchParams(window.location.search);
    const openItem = params.get('open_item');
    if (openItem) {
        const target = document.querySelector(`.archive-modal-link[data-url*="${openItem}"]`);
        if (target) target.click();
    }
});
